module.exports = __webpack_public_path__ + "static/img/9.f3aa0a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/9.png
// module id = 3EHd
// module chunks = 0